module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_buying10-62272110f43e042be68fe10ff672ac62.png";